const ACTIONS = {
  READ_PITCH: "READ_PITCH",
  READ_COMPANY: "READ_COMPANY",
  READ_OFFER: "READ_OFFER",
  READ_PREOFFER: "READ_PREOFFER",
  READ_INVESTORS: "READ_INVESTORS",
  EXPORT_INVESTORS: "EXPORT_INVESTORS",
  READ_PREOFFER_SUBSCRIBERS: "READ_PREOFFER_SUBSCRIBERS",
  READ_DOWNLOAD_PREOFFER_SUBSCRIBERS: "READ_DOWNLOAD_PREOFFER_SUBSCRIBERS",
  READ_OFFER_PERFORMANCE: "READ_OFFER_PERFORMANCE",
  READ_MANAGER_ACCOUNTS: "READ_MANAGER_ACCOUNTS",
  READ_OFFER_UPDATES: "READ_OFFER_UPDATES",

  WRITE_INVITE_MANAGER_ACCOUNTS: "WRITE_INVITE_MANAGER_ACCOUNTS",
  WRITE_UPDATE_COMPANY: "WRITE_UPDATE_COMPANY",
  //  WRITE_UPDATE_OFFER: "WRITE_UPDATE_OFFER",
  WRITE_UPDATE_PITCH: "WRITE_UPDATE_PITCH",
  WRITE_UPDATE_OFFER_UPDATE: "WRITE_UPDATE_OFFER_UPDATE",
  WRITE_UPDATE_LIVE_EVENTS: "WRITE_UPDATE_LIVE_EVENTS",
  WRITE_UPDATE_AFFILIATIONS: "WRITE_UPDATE_AFFILIATIONS",
  WRITE_UPDATE_TEAM_MEMBERS: "WRITE_UPDATE_TEAM_MEMBERS",
}

const ABILITIES = {
  "Manager": {
    READ_PITCH: true,
    READ_COMPANY: true,
    READ_OFFER: true,
    READ_PREOFFER: true,
    READ_INVESTORS: true,
    EXPORT_INVESTORS: true,
    READ_PREOFFER_SUBSCRIBERS: true,
    READ_DOWNLOAD_PREOFFER_SUBSCRIBERS: true,
    READ_OFFER_PERFORMANCE: true,
    READ_MANAGER_ACCOUNTS: true,
    READ_OFFER_UPDATES: true,
    WRITE_INVITE_MANAGER_ACCOUNTS: true,
    WRITE_UPDATE_COMPANY: true,
    WRITE_UPDATE_PITCH: true,
    // WRITE_UPDATE_LIVE_EVENTS: true, // temporarily disable editing live events for issuers
    WRITE_UPDATE_AFFILIATIONS: true,
    WRITE_UPDATE_TEAM_MEMBERS: true,
    WRITE_UPDATE_OFFER_UPDATE: true,
  },

  "Content Editor": {
    READ_PITCH: true,
    READ_COMPANY: true,
    READ_OFFER: true,
    READ_PREOFFER: true,
    READ_INVESTORS: true,
    READ_PREOFFER_SUBSCRIBERS: true,
    READ_OFFER_PERFORMANCE: true,
    READ_MANAGER_ACCOUNTS: true,
    READ_OFFER_UPDATES: true,
    WRITE_UPDATE_COMPANY: true,
    WRITE_UPDATE_PITCH: true,
  },

  "Communications": {
    READ_PITCH: true,
    READ_COMPANY: true,
    READ_OFFER: true,
    READ_PREOFFER: true,
    READ_INVESTORS: true,
    READ_PREOFFER_SUBSCRIBERS: true,
    READ_OFFER_PERFORMANCE: true,
    READ_MANAGER_ACCOUNTS: true,
    READ_OFFER_UPDATES: true,
    WRITE_UPDATE_OFFER_UPDATE: true,
  }
}

const isPermitted = (roles, action, entityId) => {
  for (const role of roles) {
    if (role.category !== "issuer") {
      continue;
    }

    if (ABILITIES[role.name]?.[action] && role.entity.id === entityId)
      return true
  }
  return false
}

const resolvedPermissions = (roles) => {
  const permitted = []

  for (const role of roles) {
    if (role.category !== "issuer") {
      continue;
    }

    if (ABILITIES[role.name]){
      permitted.push({
        entityId: role.entity.id,
        roleName: role.name,
        permissions: new Set(Object.keys(ABILITIES[role.name]))
      })
    }
  }

  const doublePermitted = {}
  for (const obj of permitted) {
    if(doublePermitted.hasOwnProperty(obj.entityId)) {
      doublePermitted[obj.entityId] = Set.new([...doublePermitted[obj.entityId], ...obj.permissions])
    }
    else {
      doublePermitted[obj.entityId] = obj.permissions
    }
  }

  return doublePermitted;
}

export {
  ABILITIES,
  ACTIONS,
  isPermitted,
  resolvedPermissions,
};